import { defineComponent as _defineComponent } from 'vue'
import {
        computed, unref,
    } from 'vue';
    import { productTypes } from '@fr/constants';
    import { THotelCardRightBlock } from '@ve/components/serpHotelCard/types';
    import ButtonV from '@ve/components/button/desktop/Button.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'SearchPageHotelCardRightBlockRedirectButton',
  props: {
    productType: null
  },
  setup(__props: any) {

const props = __props as { productType: THotelCardRightBlock['productType'] }

    

    const isHotelOfferProductType = computed(() => props.productType === productTypes.HOTEL_OFFER);
    const showToursButtonText = computed(() => (unref(isHotelOfferProductType) ? 'Показать номера' : 'Показать туры'));

return { __sfc: true,props, isHotelOfferProductType, showToursButtonText, ButtonV }
}

})